import { useEffect, useRef } from "react";
import { useStateContext } from "../../context/StateContext";

const Modal = ({ children }) => {
    const modalRef = useRef(null);
    const { setDonateModalShow, setCurrentProject } = useStateContext()

    const handleCloseModal = () => {
        setDonateModalShow(false)
        setCurrentProject(null)
    };

    const handleOutsideClick = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            handleCloseModal()
        }
    };

    useEffect(() => {
        document.body.addEventListener("click", handleOutsideClick);
        return () => {
            document.body.removeEventListener("click", handleOutsideClick);
        };
    });

    return (
        <div
            className="fixed rounded-2xl top-[25%] left-[25%] right-[25%] z-50 flex flex-col items-center justify-center w-[50%] h-max p-4 overflow-x-hidden overflow-y-auto bg-black"
        >
            <div className="relative w-full h-full py-10" ref={modalRef}>
                <div onClick={() => handleCloseModal()} className="absolute cursor-pointer px-2.5 py-1 font-bold text-black rounded-full top-1 right-1 bg-gray">x</div>
                {children}
            </div>
        </div>
    );
};

export default Modal;